import React, { useState, useEffect } from 'react';
import { getData, parseCurrency } from '../../../utils/SamuiUtils';

const EmployeeModal = ({ showEmpModal, handleEmpClose, empDataList, onRowSelectEmp }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredEmpDataList, setFilteredEmpDataList] = useState(empDataList);
    const [departmentList, setDepartmentList] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');

    useEffect(() => {
        setFilteredEmpDataList(
            empDataList.filter(emp =>
                (emp.Emp_Code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    emp.Emp_Name.toLowerCase().includes(searchTerm.toLowerCase())) &&
                (!selectedDepartment || emp.Emp_Dept === selectedDepartment)
            )
        );
    }, [searchTerm, empDataList, selectedDepartment]);

    useEffect(() => {
        if (showEmpModal) {
            setSearchTerm('');
            getDepartment();

            if (window.location.pathname === '/technical-equip-form') {
                setSelectedDepartment(9);
            } else {
                setSelectedDepartment('');
            }
        }
    }, [showEmpModal]);

    const getDepartment = async () => {
        const department = await getData('Tb_Set_Dept', `Dept_Status = 'Y' ORDER BY Dept_code ASC`);
        if (department && department.length > 0) {
            setDepartmentList(department);
        }
    };

    return (
        <>
            <div className={`modal ${showEmpModal ? 'show' : ''}`} style={{ display: showEmpModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อพนักงาน</h5>
                            <button type="button" className="close" onClick={handleEmpClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-8">
                                    <div className="form-group">
                                        <label>ค้นหาพนักงาน</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="ค้นหา รหัสพนักงาน หรือ ชื่อพนักงาน"
                                            value={searchTerm || ''}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label>เลือกแผนก</label>
                                        <select
                                            className="form-select form-control input-spacing"
                                            onChange={(e) => setSelectedDepartment(parseCurrency(e.target.value))}
                                            name="docType"
                                            value={selectedDepartment}
                                        >
                                            <option value={''}>กรุณาเลือกแผนก</option>
                                            {departmentList.map((dept) => (
                                                <option key={dept.Dept_Id} value={dept.Dept_Id}>
                                                    {dept.Dept_Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '15%' }}>รหัสพนักงาน</th>
                                            <th className="text-center" style={{ width: '55%' }}>ชื่อพนักงาน</th>
                                            <th className="text-center" style={{ width: '30%' }}>แผนก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredEmpDataList && filteredEmpDataList.length > 0 ? (
                                            filteredEmpDataList.map((emp, index) => (
                                                <tr
                                                    key={emp.Emp_Id || index + 1}
                                                    onClick={() => onRowSelectEmp(emp)}
                                                    style={{ cursor: 'pointer' }}>
                                                    <td className="text-center">{emp.Emp_Code}</td>
                                                    <td style={{ textAlign: 'left' }}>{emp.Emp_Name}</td>
                                                    <td style={{ textAlign: 'left' }}>{emp.Dept_Name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleEmpClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Overlay */}
            {showEmpModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default EmployeeModal;
